export const SIDEBAR_NAV_COLOR_CONFIGS = {
  blue: {
    active: 'text-slate-900',
    icon: 'text-slate-400 group-hover/item:text-slate-500',
    activeIcon: 'text-blue-600',
    indicator: 'bg-blue-500',
  },
  indigo: {
    active: 'text-slate-900',
    icon: 'text-slate-400 group-hover/item:text-slate-500',
    activeIcon: 'text-indigo-600',
    indicator: 'bg-indigo-500',
  },
  purple: {
    active: 'text-slate-900',
    icon: 'text-slate-400 group-hover/item:text-slate-500',
    activeIcon: 'text-purple-600',
    indicator: 'bg-purple-500',
  },
  violet: {
    active: 'text-slate-900',
    icon: 'text-slate-400 group-hover/item:text-slate-500',
    activeIcon: 'text-violet-600',
    indicator: 'bg-violet-500',
  },
  cyan: {
    active: 'text-slate-900',
    icon: 'text-slate-400 group-hover/item:text-slate-500',
    activeIcon: 'text-cyan-600',
    indicator: 'bg-cyan-500',
  },
  sky: {
    active: 'text-slate-900',
    icon: 'text-slate-400 group-hover/item:text-slate-500',
    activeIcon: 'text-sky-600',
    indicator: 'bg-sky-500',
  },
  orange: {
    active: 'text-slate-900',
    icon: 'text-slate-400 group-hover/item:text-slate-500',
    activeIcon: 'text-orange-600',
    indicator: 'bg-orange-500',
  },
  amber: {
    active: 'text-slate-900',
    icon: 'text-slate-400 group-hover/item:text-slate-500',
    activeIcon: 'text-amber-600',
    indicator: 'bg-amber-500',
  },
  green: {
    active: 'text-slate-900',
    icon: 'text-slate-400 group-hover/item:text-slate-500',
    activeIcon: 'text-emerald-600',
    indicator: 'bg-emerald-500',
  },
  emerald: {
    active: 'text-slate-900',
    icon: 'text-slate-400 group-hover/item:text-slate-500',
    activeIcon: 'text-emerald-600',
    indicator: 'bg-emerald-500',
  },
  teal: {
    active: 'text-slate-900',
    icon: 'text-slate-400 group-hover/item:text-slate-500',
    activeIcon: 'text-teal-600',
    indicator: 'bg-teal-500',
  },
  slate: {
    active: 'text-slate-900',
    icon: 'text-slate-400 group-hover/item:text-slate-500',
    activeIcon: 'text-slate-700',
    indicator: 'bg-slate-500',
  },
};

const DEFAULT_SIDEBAR_NAV_COLOR = 'blue';

const VIEW_SIDEBAR_COLOR_FALLBACKS = [
  'green',
  'blue',
  'indigo',
  'teal',
  'cyan',
  'violet',
  'orange',
  'purple',
];

export const getSidebarNavColorConfig = (color = DEFAULT_SIDEBAR_NAV_COLOR) =>
  SIDEBAR_NAV_COLOR_CONFIGS[color] || SIDEBAR_NAV_COLOR_CONFIGS[DEFAULT_SIDEBAR_NAV_COLOR];

export const getSidebarNavIconColorClass = (color = DEFAULT_SIDEBAR_NAV_COLOR, isActive = false) => {
  const config = getSidebarNavColorConfig(color);
  return isActive ? config.activeIcon : config.icon;
};

export const getSidebarNavIndicatorClass = (color = DEFAULT_SIDEBAR_NAV_COLOR) =>
  getSidebarNavColorConfig(color).indicator;

export const resolveSidebarNavColor = (color, fallbackIndex = 0) => {
  if (typeof color === 'string' && SIDEBAR_NAV_COLOR_CONFIGS[color]) {
    return color;
  }
  return VIEW_SIDEBAR_COLOR_FALLBACKS[fallbackIndex % VIEW_SIDEBAR_COLOR_FALLBACKS.length];
};
